const COMMON_SORT_ASC = 'common-name-asc';
const COMMON_SORT_DESC = 'common-name-desc';
const GRID_SELECTOR = '.product-grid';

function currentSort() {
  return new URLSearchParams(location.search).get('sort_by');
}

function commonSortActive() {
  const s = currentSort();
  return s === COMMON_SORT_ASC || s === COMMON_SORT_DESC;
}

function applyCommonSort() {
  const grid = document.querySelector(GRID_SELECTOR);
  if (!grid || !commonSortActive()) return;
  const descending = currentSort() === COMMON_SORT_DESC;
  Array.from(grid.children)
    .filter((el) => el.tagName === 'LI')
    .sort((a, b) => {
      const an = (a.dataset.commonName || '').toLowerCase();
      const bn = (b.dataset.commonName || '').toLowerCase();
      return descending ? bn.localeCompare(an) : an.localeCompare(bn);
    })
    .forEach((el) => grid.appendChild(el));
}

function syncSortState() {
  document.documentElement.classList.toggle('cn-sort-active', commonSortActive());
}

function init() {
  syncSortState();
  applyCommonSort();
  const observer = new MutationObserver(() => {
    syncSortState();
    if (!commonSortActive()) return;
    observer.disconnect();
    applyCommonSort();
    observer.observe(document.body, { childList: true, subtree: true });
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}